export default __webpack_public_path__ + "static/media/rare3.da4a8a2d.gif";